import { GoogleAuthProvider } from "firebase/auth";
import { getAuth, signInWithRedirect } from "firebase/auth";

export const signin = () => {
  const provider = new GoogleAuthProvider();
  const auth = getAuth();
  signInWithRedirect(auth, provider).catch((err) => {
    console.log(err);
    alert("サインインに失敗しました。");
  });
};
